<script>
    /**
     * zeluslugi.ru
     * @author      delphinpro <delphinpro@gmail.com>
     * @copyright   copyright © 2018 delphinpro
     * @license     licensed under the MIT license
     */

    export default {
        name : "calc-tooltip",
        props: {
            content: String,
        },
    };
</script>

<template>
  <v-popover
      offset="10"
      trigger="hover"
      popoverWrapperClass="tooltip-wrapper"
      placement="auto"
  >
    <span class="tooltip-target b3 tooltip-button">?</span>
    <template slot="popover">
      <div v-html="content"></div>
    </template>
  </v-popover>
</template>
